import React from 'react'
import { withStyles } from '@material-ui/core/styles'

const styles = theme => ({
  drawerHeader: {
    dispaly: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    height: 56
  }
})

const DebugDrawerHeader = ({ children, classes }) => (
  <div className={classes.drawerHeader}>{children}</div>
)

export default withStyles(styles)(DebugDrawerHeader)



// WEBPACK FOOTER //
// ./src/debug/DebugDrawerHeader.js